import { ITableIndex } from "./ITableIndex";

export class TableIndex {
  constructor(
    public row: number,
    public column: number,
  ) {
  }

  clone(): TableIndex {
    return new TableIndex(this.row, this.column);
  }

  static from(source: ITableIndex): TableIndex {
    return new TableIndex(source.row, source.column);
  }

  static to(source: TableIndex): ITableIndex {
    return {
      row: source.row,
      column: source.column,
    };
  }
}
